import { dotSeparator } from 'data/consts';
import { basketSetDegraded, cartId, cartInfo, userAuth } from 'data/cookie';
import { ipAddress } from 'data/regexp';
import cookies from 'js-cookie';

export const getDomainForCookie = () => {
    const { hostname } = location;
    const startIndex = hostname.indexOf(dotSeparator);
    const isIpAddress = ipAddress.test(hostname);
  
    if (!isIpAddress && startIndex !== -1) {
      return hostname.split(dotSeparator).slice(-2).join(dotSeparator);
    }
  
    return '';
};
  
export const getCookie = (name: string) => cookies.get(name);
  
export const setCookie: typeof cookies.set = (name, value, options) => {
    return cookies.set(name, value, {
      domain: getDomainForCookie(),
      ...options,
    });
};
  
export const removeCookie: typeof cookies.remove = (name, options) => {
    return cookies.remove(name, {
      domain: getDomainForCookie(),
      ...options,
    });
};


export const getCartInfo = () => getCookie(cartInfo);
export const getCartId = () => getCookie(cartId);
export const isUserAuth = () => getCookie(userAuth) === 'true';
export const isBasketSetDegraded = () => getCookie(basketSetDegraded) === 'true';
